<script>
  import GalleryContainer from "./Gallery/Container.svelte";
  import ClickStoryContainer from "./ClickStory/Container.svelte";
  import { initClient } from "@urql/svelte";
  import { endpointUrl } from "./Api/config";
  import { nanoID, adData, billboardNode } from "./Api/store";
  import { router } from "yrv/build/dist";

  const path = "/api/wisch";

  initClient({
    url: endpointUrl + path,
  });

  export let id;
  export let itemId;
  export let adSpread = 3;
  export let adTimeout = 7;
  export let type = "click-story";
  const baseUrl = window.location.pathname;

  let sticky = false;

  const billboard = document.querySelector(`[x-data="ad('Billboard')"]`);

  if (billboard) {
    billboardNode.set(billboard);
    sticky = billboard.dataset.sticky || false;
    if (sticky && sticky !== "true") {
      sticky.split(" ").forEach((cssClass) => {
        billboard.classList.add(cssClass);
      });
    }
  }

  adData.set({
    show: false,
    navigateCount: 0,
    spread: adSpread,
    timeout: adTimeout,
  });

  let timer;
  let firstRun = true;

  router.subscribe((event) => {
    if (!event.initial) {
      if (firstRun) {
        firstRun = false;
        return;
      }
      clearTimeout(timer);
      timer = setTimeout(() => {
        window.dispatchEvent(new CustomEvent("refreshAds"));
        adData.update((storeObj) => {
          storeObj.navigateCount = storeObj.navigateCount + 1;
          return storeObj;
        });
      }, 750);
    }
  });

  nanoID.set(id);

  const components = {
    gallery: GalleryContainer,
    "click-story": ClickStoryContainer,
  };
</script>

<svelte:component this={components[type]} {itemId} {baseUrl} {sticky} />
